import type { ReactNode } from "react";

import { cva } from "~/v2/utils/cn";

interface OptionChainButtonProps {
  onClick: () => void;
  type: "bid" | "ask";
  children: ReactNode;
  disabled?: boolean;
  isSelected?: boolean;
}

/**
 * `type` sets the colour and `isSelected` fills it in, so the fill colour is a
 * property of the pair rather than of either one -- which is what the two
 * compound entries say. Selected text turns white last, after the type's own
 * text colour, so the order of the variants is load-bearing.
 */
const optionChainButton = cva(
  "flex min-w-12 justify-center rounded border px-2 py-1 align-center text-xs",
  {
    variants: {
      type: {
        bid: "border-red-600 text-red-600",
        ask: "border-green-600 text-green-600",
      },
      isSelected: { true: "text-white", false: "" },
    },
    compoundVariants: [
      { type: "bid", isSelected: true, class: "bg-red-600" },
      { type: "ask", isSelected: true, class: "bg-green-600" },
    ],
    defaultVariants: { isSelected: false },
  },
);

export const OptionChainButton = ({
  children,
  type,
  onClick,
  disabled,
  isSelected,
}: OptionChainButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    className={optionChainButton({ type, isSelected })}
  >
    {children}
  </button>
);
